import AppBtn from '../app-btn'
import AppArrowLink from '../app-arrow-link'


// URL list
import URL from '../../../config.url'


export default
{
    name: 'app-teams-table-row',

    components:
    {
        AppBtn,
        AppArrowLink
    },

    props:
    {
        index: { type: Number, default: null },
        team: { type: Object, default: {} },
        contentGlobal: { type: Object, default: {} },
        contentPage: { type: Object, default: {} }
    },

    data()
    {
        return {
            url: URL
        }
    },

    created()
    {
    },

    methods:
    {
        getTeamUrlBySlug(slug)
        {
            return this.$root.getPageURLFromID('teamProfile').replace(':slug', slug)
        }
    }
}



// WEBPACK FOOTER //
// ./src/scripts/components/app-teams-table-row/script.js